import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import {
  FormBuilderService,
  IFormGroupConfig,
  UIBaseModal,
  UIButton,
  UIFormModule,
  UIIcon,
  UIModal,
} from '@shared/ui';
import { catchError } from 'rxjs';
import { ParkingEventsService } from '../../services';
import { parkingEventsFormConfig } from '../../configs';
import { UserService } from '@aggregator/core';

@Component({
  selector: 'aggregator-operator-parking-events-details-modal',
  templateUrl: './operator-parking-events-details-modal.component.html',
  styleUrl: './operator-parking-events-details-modal.component.scss',
  standalone: true,
  imports: [UIModal, UIFormModule, UIButton, UIIcon],
  providers: [ParkingEventsService],
})
export class OperatorParkingEventsDetailsModal extends UIBaseModal implements OnInit {
  isLoadingData = false;
  isSaving = false;

  form?: FormGroup;
  formConfig?: IFormGroupConfig;

  get canNotSave(): boolean {
    return this.form?.invalid || !this.form?.dirty;
  }

  get isDetails(): boolean {
    return !!this.data;
  }

  get modalTitle(): string {
    return this.isDetails ? 'Изменить данные' : 'Добавить';
  }

  get itemId(): string {
    return this.data as string;
  }

  get operatorId(): string | undefined {
    return this.userService.userInfo?.operatorId;
  }

  get userId(): string | undefined {
    return this.userService.userInfo?.id;
  }

  constructor(
    private formBuilder: FormBuilderService,
    private service: ParkingEventsService,
    private userService: UserService,
    private destroy$: DestroyRef,
  ) {
    super();
  }
  ngOnInit(): void {
    this.formConfig = parkingEventsFormConfig(this.operatorId ?? '');
    this.form = this.formBuilder.build(this.formConfig);
    if (this.itemId) {
      this.isLoadingData = true;
      this.service
        .getById(this.itemId)
        .pipe(takeUntilDestroyed(this.destroy$))
        .subscribe(response => {
          if (response?.value) {
            this.form?.patchValue(response.value);
          }
          this.isLoadingData = false;
        });
    }
  }

  onSave(): void {
    if (this.isSaving || this.canNotSave) {
      return;
    }
    this.isSaving = true;
    this.form?.disable();

    const formData = this.form?.getRawValue();
    formData.freeSpotsCount = new Number(formData.freeSpotsCount);
    formData.userId = this.userId;
    formData.operatorId = this.operatorId;

    (this.isDetails ? this.service.update(this.itemId, formData) : this.service.create(formData))
      .pipe(
        takeUntilDestroyed(this.destroy$),
        catchError(error => {
          this.isSaving = false;
          this.form?.enable();
          throw error;
        }),
      )
      .subscribe(() => {
        this.onAfterClose(true);
      });
  }
}
